module.exports = __webpack_public_path__ + "img/classifyIco8.14e5de4b.png";